import {
  Component,
  OnDestroy,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  SuiModal,
  SuiModalService,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { CompanyService, DocumentService } from '../../services';
import { AuthenticationService } from 'src/modules/core/services';
import { OrganizationService } from 'src/modules/features/contractor/services';
import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';
import { environment } from 'src/environments/environment';
import { AolService } from '../../services/aol';
import { type } from 'os';
import { LinkDocumentModal } from '../link-document-type-modal/link-document-type-modal.component';
import { ActivatedRoute } from '@angular/router';

interface INewDirectorModalContext {
  data?: any;
  title?: string;
  isEdit?: boolean;
}
interface Document {
  documentTypeId: string;
  documentTypeName: string;
  isRequired: boolean;
  isActive: boolean;
  dateCreated: string;
  dateModified: string;
  group: any;
  createdBy: string;
  modifiedBy: string;
  uploadedFiles?: File[];
}
@Component({
  selector: 'app-new-personnel-modal',
  templateUrl: './new-personnel-modal.component.html',
  styleUrls: ['./new-personnel-modal.component.scss'],
})
export class NewPersonnelModalComponent implements OnInit, OnDestroy {
  @ViewChild('input') input: ElementRef;
  @ViewChild('uploadDoc') uploadDoc: ElementRef;
  searchable: boolean = true;
  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean;

  companyDirectorForm: FormGroup;
  companyDirector: any;

  companyType: Array<any> = [];
  ownershipType: Array<any> = [];
  countries: Array<any> = [];
  organizationId: string;
  currentForm: any;
  changeRequestId: string;
  heading: string;
  replyForm: FormGroup;
  selectedFile;
  fileNameArr: any = [];
  uploadFormData: any;
  fileError;
  allAffiliateTypes!: any[];
  selectedAffiliateTypes: any[] = [];
  companyAffiliateTypes!: any[];
  affiliateTypeTouched = false;
  allDocuments: any = [];
  documentUploaded: any = [];
  existingPersonnel: any;
  fileName;
  baseUrl: string = environment.API_SERVER;
  documentData;
  type;
  userData;
  typeId: string = 'Individual';
  individualType = 'Individual';
  companyRepType = 'Company Representative';
  documentFilterCompany = {
    groupOp: 'OR',
    rules: [],
  };
  typeName;
  typeIds;
  documentss: Document[];

  onFileChanges(event: any, document: Document): void {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const uploadedFiles: File[] = Array.from(fileList);
      document.uploadedFiles = document.uploadedFiles || [];
      document.uploadedFiles = [...document.uploadedFiles, ...uploadedFiles];
    }
    this.uploadedDocuments = this.documentss
      .filter((doc) => doc.uploadedFiles && doc.uploadedFiles.length > 0)
      .map(({ uploadedFiles, ...rest }) => ({ ...rest, uploadedFiles }));
  }
  uploadedDocuments: any = [];
  removeDocument(index: number): void {
    this.documentss.splice(index, 1);
  }

  removeFile(document: Document, fileIndex: number): void {
    if (document.uploadedFiles) {
      document.uploadedFiles.splice(fileIndex, 1);
    }
  }
  removeLinkedDocument(doc, index) {
    if (doc) {
      this.allLinkedDocuments.splice(index, 1);
    }
  }
  editLinkedDocument(doc, index, data) {
    this.modalService
      .open(
        new LinkDocumentModal(
          `Edit Selected existing documents from ${data} Document Type`,
          doc,
          data,
          this.uploads,
          ModalSize.Tiny
        )
      )
      .onApprove((documents: any) => {
        console.log(documents, 'doc');
        if (doc) {
          this.allLinkedDocuments[index] = documents[0];
        }
      })
      .onDeny(() => {});
  }
  editFile(event: any, document: Document, fileIndex: number): void {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const newFile: File = fileList[0];

      // Replace the existing file at the specified index
      if (document.uploadedFiles && document.uploadedFiles[fileIndex]) {
        document.uploadedFiles[fileIndex] = newFile;
      }
    }
  }

  onSubmit(): void {
    // Collect the uploaded documents for submission
    const uploadedDocuments = this.documentss.filter(
      (doc) => doc.uploadedFiles
    );

    // Send the uploadedDocuments array to your backend for further processing
    console.log('Uploaded Documents:', uploadedDocuments);
  }
  constructor(
    private companySvc: CompanyService,
    private modalService: SuiModalService,
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,

    private authSvc: AuthenticationService,
    private organizationSvc: OrganizationService,
    public modal: SuiModal<INewDirectorModalContext, void, void>,
    private documentSvc: DocumentService,
    private companyOwnershipService: CompanyOwnershipService,
    private AolService: AolService,
    private route: ActivatedRoute
  ) {
    this.heading =
      modal.context.data.item == 'SHAREHOLDER_STRUCTURE'
        ? 'Shareholder'
        : 'Director';
    this.companyType = modal.context.data.companyType;
    this.route.queryParams.subscribe((params) => {
      // Access individual query parameters here
      this.typeName = params['typeName'];
      this.typeIds = params['typeId'];
    });

    this.countries = modal.context.data.countries;
    this.ownershipType = modal.context.data.ownershipType;
    this.existingPersonnel = modal.context.data.director;
    console.log(window.location.href);
    if (window.location.href.includes('director')) {
      this.type = 'director_type';
    } else if (window.location.href.includes('shareholder')) {
      this.type = 'shareholder_type';
    } else if (window.location.href.includes('secretary')) {
      this.type = 'company secretary_type';
    } else {
      this.type = this.typeIds;
    }
    this.organizationId = window.localStorage.getItem('organizationId');
    this.userData = JSON.parse(window.localStorage.getItem('organization'));
    this.getDocumentUploaded();

    this.companyDirectorForm = fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      address: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: ['', [Validators.required, Validators.pattern(/^\d{11}$/)]],
      middleName: [''],
      shareholderType: [''],
      companyName: [''],
      companyRegNumber: [''],
      gender: ['', Validators.required],
      nationalityId: ['', Validators.required],
      countryOfOriginId: ['', Validators.required],
      nationalIdNumber: ['', Validators.required],
      organizationOwnershipTypeId: [''],
      organizationOwnershipId: [''],
      shareholding: [0, Validators.required],
      actionType: [''],
      example: [''],
    });
    if (modal.context.isEdit) {
      console.log(modal.context.data, 'modal.context.data');
      this.companyDirector = modal.context.data.director;
      if (modal.context.data.director.photographDocumentId) {
        // this.fileNamePhoto =
        //   modal.context.data.director.photographDocumentId.split('______')[1];
        this.getDocumentPath(modal.context.data.director.photographDocumentId);
      }
      if (modal.context.data.director.documents) {
        this.allLinkedDocuments = modal.context.data.director.documents;
      }
      this.companyDirectorForm.patchValue(this.companyDirector);
    }
    this.currentForm = this.companyDirectorForm.value;
    this.replyForm = fb.group({
      documentTypeId: ['CHANGE_REQUEST_DOCUMENT', Validators.required],
      documentName: ['PROFILE_PHOTO', Validators.required],
      document: ['', Validators.required],
      attachment: [true],
      documentDescription: ['string'],
    });
  }
  allLinkedDocuments: any = [];
  LinkDocument(data) {
    this.modalService
      .open(
        new LinkDocumentModal(
          `Select and link existing documents from ${data} Document Type`,
          '',
          data,
          this.uploads,
          ModalSize.Tiny
        )
      )
      .onApprove((documents: any) => {
        console.log(documents, 'doc');
        documents.map((item) => this.allLinkedDocuments.push(item));
      })
      .onDeny(() => {});
  }

  returnDocumentType(data, id, typeId) {
    const filtered = data.filter((item) => {
      if (item.documentTypeId.documentTypeName) {
        return item.documentTypeId.documentTypeName === id;
      } else {
        return item.documentTypeId.documentTypeId === typeId;
      }
    });
    return filtered;
  }
  uploads: any = [];
  getDocumentUploaded() {
    this.pending = true;
    this.AolService.getDocumentUpload({
      optionId: this.type,
    }).subscribe(
      (res: any) => {
        this.pending = false;
        this.uploads = res.filter((item) => item.isActive);
        console.log(this.uploads, 'this.uploads');
        this.documentss = this.uploads.map((doc) => ({
          ...doc,
          uploadedFiles: [],
        }));
        console.log(this.documentss, 'document');
      },
      (error) => {
        this.pending = false;
        this.error = error.error;
      }
    );
  }

  onTypeChange(data) {
    this.typeId = data;
    console.log(this.typeId);
  }
  getDocumentPath(data) {
    this.pending = true;
    this.AolService.getDocument({ documentId: data }).subscribe(
      (res: any) => {
        this.pending = false;
        this.fileNamePhoto = res.documentPath.split('______')[1];
      },
      (error) => {
        this.pending = false;
        this.error = error.error;
      }
    );
  }

  addArrayAtIndex(index, newArray) {
    if (index >= 0 && index <= this.fileNameArr.length) {
      this.fileNameArr.splice(index, 0, newArray);
    } else {
      this.fileNameArr.push(newArray);
    }
    console.log(this.fileNameArr, 'filenamearr');
  }
  updateValuesInArrayAtIndex(index, updatedValues) {
    // Check if the index is within bounds
    if (index >= 0 && index < this.fileNameArr.length) {
      // Update values in the specified array
      this.fileNameArr[index] = updatedValues;
    }
  }
  updateArrayAtIndex(index, valueOrArray) {
    if (index >= 0 && index < this.fileNameArr.length) {
      this.fileNameArr[index].push(valueOrArray);
    } else {
      if (Array.isArray(valueOrArray)) {
        this.fileNameArr.splice(index, 0, valueOrArray);
      } else {
        this.fileNameArr.push([valueOrArray]);
      }
    }
    console.log(this.fileNameArr, 'filenamearrupsdate');
  }

  selectedFilePhoto;
  fileNamePhoto;
  onFileChangeData(event) {
    const files = event.target.files;
    if (!files) {
      return;
    }
    if (this.isFileTypeAllowed(files[0])) {
      this.selectedFilePhoto = files[0];
      this.fileNamePhoto = this.selectedFilePhoto['name'];
    } else {
      this.error =
        'Invalid file type. Please select a .jpg, .jpeg, or .png file.';
      return;
    }
  }
  isFileTypeAllowed(file: File): boolean {
    const allowedTypes = ['.jpg', '.jpeg', '.png'];
    const fileType = '.' + file.name.split('.').pop();
    return allowedTypes.includes(fileType.toLowerCase());
  }
  isFileTypeAllowedDocument(file: File): boolean {
    // Check if the file type is allowed
    const allowedTypes = [
      '.jpg',
      '.jpeg',
      '.png',
      '.pdf',
      '.doc',
      '.docx',
      '.odf',
      '.xls',
      '.xlsx',
    ];
    const fileType = '.' + file.name.split('.').pop();
    return allowedTypes.includes(fileType.toLowerCase());
  }

  save() {
    if (!this.selectedFilePhoto) {
      this.updateDirector(
        null,
        this.companyDirector.photographDocumentId,
        this.companyDirector.photographDocumentPath
      );
    } else {
      let data: any = this.replyForm.value;
      const formData: FormData = new FormData();
      formData.append(
        'file',
        this.selectedFilePhoto,
        this.selectedFilePhoto.name
      );
      let payload: any = { formValue: data, formData: formData };
      this.uploadFormData = payload['formData'];
      const values = payload['formValue'];
      // this.dataSent = values;
      // console.log(this.dataSent);
      const jsonse = JSON.stringify(values);
      const blob = new Blob([jsonse], { type: 'application/json' });
      this.uploadFormData.append('data', blob);
      this.onUploadFilePhoto(this.uploadFormData);
    }
  }

  onUploadFilePhoto(data) {
    this.success = null;
    this.error = null;
    this.pending = true;
    this.documentSvc
      .uploadDocument({ organizationId: this.organizationId, body: data })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.updateDirector(null, res.documentId, res.documentPath);
        },
        (error) => {
          this.pending = false;
          this.error = 'Error while uploading Documents Retry';
        }
      );
  }

  isFieldValid(field: string) {
    return (
      (!this.companyDirectorForm.get(field).valid &&
        this.companyDirectorForm.get(field).touched) ||
      (this.companyDirectorForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  formNotChanged() {
    return (
      JSON.stringify({ ...this.companyDirectorForm.value }) ==
      JSON.stringify({ ...this.currentForm })
    );
  }

  affiliateTypeChanged(event: any) {
    console.log(this.companyDirectorForm);
    this.affiliateTypeTouched = true;
    if (event.target.checked) {
      let currentType = this.companyAffiliateTypes.find(
        (affiliateType) => affiliateType.ownershipTypeId == event.target.value
      );
      this.selectedAffiliateTypes.push({
        ownershipTypeName: currentType.ownershipType,
        organizationOwnershipTypeId: currentType.ownershipTypeId,
      });
    } else {
      // find the unselected element index
      let i: number = this.selectedAffiliateTypes.findIndex(
        (affiliateType) =>
          affiliateType.organizationOwnershipTypeId == event.target.value
      );
      console.log(i);

      this.selectedAffiliateTypes.splice(i, 1);
    }
    console.log(this.selectedAffiliateTypes);
  }

  affiliateTypeInvalid() {
    if (this.existingPersonnel?.organizationOwnershipTypeId) return false;
    // return this.affiliateTypeTouched && !this.selectedAffiliateTypes.length;
    return this.affiliateTypeTouched && this.selectedAffiliateTypes.length == 0;
  }

  affiliateTypeInvalid2() {
    if (this.existingPersonnel?.organizationOwnershipTypeId) return false;
    // return !this.selectedAffiliateTypes.length;
    return this.selectedAffiliateTypes.length == 0;
  }
  uploadSupportingFilesInvalid() {
    if (!this.uploads) {
      console.log(this.uploads.length, 'without upload supporting files');
      return true;
    }
    if (this.uploads.length > 0) {
      return (
        this.uploadedDocuments?.length < 1 &&
        this.allLinkedDocuments?.length < 1
      );
    }
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }

  getFileSizePhotograph(fileInput: number) {
    if (fileInput) {
      const fileSizeBytes = fileInput;
      const fileSizeKB = fileSizeBytes / 1024;
      const fileSizeMB = fileSizeKB / 1024;
      console.log(
        `File size: ${fileSizeBytes} bytes, ${fileSizeKB} KB, ${fileSizeMB} MB`
      );
      if (fileSizeMB > 1) {
        return false;
      } else {
        return true;
      }
    }
  }
  submit() {
    if (this.selectedFilePhoto) {
      if (!this.getFileSizePhotograph(this.selectedFilePhoto.size)) {
        this.error = `File (${this.selectedFilePhoto.name}) size is too large, Maximum file size is 1MB`;
        return;
      }
    }
    let data: any = this.uploadedDocuments;
    if (data && data.length > 0) {
      for (const documentType of data) {
        for (const document of documentType.uploadedFiles) {
          const size = document.size;
          if (size > 10 * 1024 * 1024) {
            this.error = `File (${document.name}) size is too large, Maximum file size is 10MB`;
            return;
          }
        }
      }
    }
    this.pending = true;
    if (this.typeId === 'Company Representative') {
      if (
        this.companyDirectorForm.value.companyName &&
        this.companyDirectorForm.value.companyRegNumber
      ) {
        this.companyDirectorForm.value.shareholderType = 'Company';
        delete this.companyDirectorForm.value.example;
        this.proceed();
      } else {
        this.error = 'Please fill all required fields';
        this.pending = false;
      }
    } else {
      delete this.companyDirectorForm.value.example;
      this.companyDirectorForm.value.companyName = '';
      this.companyDirectorForm.value.companyRegNumber = '';
      this.proceed();
    }
  }
  proceed() {
    if (
      this.selectedFilePhoto ||
      (this.modal.context.isEdit &&
        this.modal.context.data.director.photographDocumentId)
    ) {
      if (
        this.modal.context.isEdit &&
        this.modal.context.data.director.photographDocumentId
      ) {
        this.save();
      } else {
        this.save();
      }
    } else {
      this.error = 'Please upload a photograph';
      this.pending = false;
    }
  }
  printForm() {
    console.log(this.companyDirectorForm.valid, this.companyDirectorForm.value);
  }

  updateDirector(val, id, path) {
    this.pending = true;
    console.log(this.uploadedDocuments, 'uploadedDopcument');
    if (
      (this.uploadedDocuments && this.uploadedDocuments.length > 0) ||
      this.allLinkedDocuments.length > 0
    ) {
      val = this.modal.context.isEdit ? 'UPDATE' : 'ADD';
      let organizationId = window.localStorage.getItem('organizationId');
      this.pending = true;
      this.companyDirectorForm.value.actionType = val;
      this.currentForm.actionType = val;
      this.companyDirectorForm.value.photographDocumentId = id;
      this.companyDirectorForm.value.photographDocumentPath = path;
      this.companyDirectorForm.value.share =
        this.companyDirectorForm.value.shareholding;

      // this.companyDirectorForm

      console.log(
        this.companyDirectorForm.value,
        this.selectedAffiliateTypes[0]
      );
      this.nullify();
      let payload = {
        fromValue: this.currentForm,
        toValue: {
          ...this.companyDirectorForm.value,
          // affiliateTypes: this.selectedAffiliateTypes
          ...this.selectedAffiliateTypes[0],
        },
      };
      console.log(payload);
      this.submitDoc(payload);
    } else {
      // this.input.nativeElement.focus();
      this.pending = false;
      this.error = 'Please upload all required documents';
      if (this.uploads.length === 0) {
        this.submitDataWithNoDocs(val, id, path);
      }
    }
  }

  submitDataWithNoDocs(action, id, path) {
    this.pending = false;
    this.error = null;
    console.log(this.uploads.length, 'without upload supporting files');
    action = this.modal.context.isEdit ? 'UPDATE' : 'ADD';
    this.companyDirectorForm.value.actionType = action;
    this.currentForm.actionType = action;
    this.companyDirectorForm.value.photographDocumentId = id;
    this.companyDirectorForm.value.photographDocumentPath = path;
    this.companyDirectorForm.value.share =
      this.companyDirectorForm.value.shareholding;
    let payload = {
      fromValue: this.currentForm,
      toValue: {
        ...this.companyDirectorForm.value,
        // affiliateTypes: this.selectedAffiliateTypes
        ...this.selectedAffiliateTypes[0],
      },
    };
    console.log(payload);
    const response = payload;
    const result: any = {
      fromValue: response.fromValue,
      toValue: response.toValue,
      // document: this.documentsUploaded,
      affiliateTypes: this.selectedAffiliateTypes,
    };
    const subItem = { ...result };
    this.input.nativeElement.focus();
    this.success = `Record ${this.modal.context.isEdit ? 'Updated' : 'Added'}`;
    console.log(subItem, 'result');
    setTimeout(() => {
      this.modal.approve(subItem);
      // this.pending = false;
      return;
    }, 3000);
  }

  nullify() {
    this.success = null;
    this.error = null;
  }

  submitDoc(response) {
    console.log(this.allLinkedDocuments);
    this.pending = true;
    this.formSubmitAttempt = false;
    console.log(this.uploadedDocuments, 'uploadedDopcument');
    if (this.uploadedDocuments.length > 0) {
      let data: any = this.uploadedDocuments;
      for (const documentType of data) {
        for (const document of documentType.uploadedFiles) {
          const formData: FormData = new FormData();
          const file = document;
          formData.append('file', file);
          let formValue = {
            documentDescription: 'supporting document',
            documentName: documentType.documentTypeName,
            documentTypeId: documentType.documentTypeId,
          };
          let payload: any = { formValue: formValue, formData: formData };
          this.allDocuments.push(payload);
        }
      }

      this.allDocuments.map((item, index) => {
        this.processUpload(item, index, response);
      });
    } else if (this.allLinkedDocuments.length > 0) {
      this.pending = true;
      this.onUploadFile(response);
    } else {
      this.formSubmitAttempt = true;
      this.pending = false;
      this.error = 'Please upload all required documents';
    }
  }
  processUpload(data, i, response) {
    this.pending = true;
    let uploadFormData = data['formData'];
    const values = data['formValue'];
    const jsonse = JSON.stringify(values);
    const blob = new Blob([jsonse], { type: 'application/json' });
    uploadFormData.append('data', blob);
    this.success = null;
    this.error = null;
    this.pending = true;
    this.documentSvc
      .uploadDocument({
        organizationId: this.organizationId,
        body: uploadFormData,
      })
      .subscribe(
        (res: any) => {
          // this.pending = false;
          this.documentUploaded.push(res);
          if (this.documentUploaded.length === this.allDocuments.length) {
            console.log(
              this.documentUploaded,
              this.documentUploaded.length,
              'this.documentUploaded'
            );
            this.onUploadFile(response);
            // console.log(index, this.allDocuments.length, 'before');
          }
        },
        (error) => {
          this.pending = false;
          this.error = 'Error while uploading Documents Retry';
        }
      );
  }
  onUploadFileSupporting(data, response) {
    this.success = null;
    this.error = null;
    this.pending = true;
    this.documentSvc
      .uploadDocument({ organizationId: this.organizationId, body: data })
      .subscribe(
        (res: any) => {
          this.pending = false;
          // this.documentsUploaded.push(data);
          // this.onUploadFile(data, response);
        },
        (error) => {
          this.pending = false;
          this.error = 'Error while uploading Documents Retry';
        }
      );
  }

  onUploadFile(item) {
    this.pending = true;
    const response = item;

    console.log(
      this.documentUploaded,
      this.allLinkedDocuments,
      'this.allLinkedDocuments'
    );
    let emptyArray = [];
    this.allLinkedDocuments.map((item) => emptyArray.push(item));
    this.documentUploaded.map((item) => emptyArray.push(item));
    // this.documentUploaded.push(...this.allLinkedDocuments);
    // this.allLinkedDocuments.push(...this.documentUploaded);
    console.log(emptyArray, 'this.documentUploaded');
    let requiredDocument = this.uploads.filter((item) => {
      return item['isRequired'];
    });
    // const objectsNotInSecondArray = requiredDocument.filter(
    //   (item) =>
    //     !this.documentUploaded.some(
    //       (secondItem) =>
    //         secondItem.documentTypeId?.documentTypeId === item.documentTypeId
    //     )
    // );
    // Create a Set containing unique documentTypeId values from documentUploaded
    const documentTypeIdSet = new Set(
      emptyArray.map((item) => item.documentTypeId?.documentTypeId)
    );

    // Filter the requiredDocument array based on the presence of documentTypeId in the Set
    const objectsNotInSecondArray = requiredDocument.filter(
      (item) => !documentTypeIdSet.has(item.documentTypeId)
    );
    console.log(objectsNotInSecondArray, 'objectsNotInSecondArray');
    if (objectsNotInSecondArray.length > 0) {
      this.pending = false;
      this.error = 'Please upload the required Document';
      return;
    } else {
      response.toValue.documents = emptyArray;
    }
    const result: any = {
      fromValue: response.fromValue,
      toValue: response.toValue,
      // document: this.documentsUploaded,
      affiliateTypes: this.selectedAffiliateTypes,
    };

    const subItem = { ...result };
    this.input.nativeElement.focus();

    this.success = `Record ${this.modal.context.isEdit ? 'Updated' : 'Added'}`;
    console.log(subItem, 'result');
    setTimeout(() => {
      this.modal.approve(subItem);
      // this.pending = false;
      return;
    }, 3000);
  }

  getAffiliateTypes(companyTypeId: string) {
    if (companyTypeId == 'public_company_limited_by_shares_actual') {
      companyTypeId = 'limited_liability';
    }
    this.companyOwnershipService
      .getOwnershipsForCompanyType({ companyTypeId: companyTypeId })
      .subscribe(
        (res: any[]) => {
          this.companyAffiliateTypes = res;
          console.log(this.companyAffiliateTypes, 'this.companyAffiliateTypes');
        },
        (error) => {
          console.log(error);
          this.pending = false;
        }
      );
  }

  getAllAfiliateTypes() {
    this.companyOwnershipService.getOwnershipTypes().subscribe(
      (res: any[]) => {
        this.allAffiliateTypes = res;
        let t = setInterval(() => {
          if (this.pending == false) {
            clearInterval(t);
          }

          if (this.companyAffiliateTypes) {
            this.companyAffiliateTypes.forEach((companyAffiliateType) => {
              this.allAffiliateTypes.every((affiliateType) => {
                if (
                  companyAffiliateType.ownershipType == affiliateType.optionName
                ) {
                  companyAffiliateType.ownershipTypeId = affiliateType.optionId;
                  return false;
                }
                return true;
              });
            });
            if (this.existingPersonnel?.organizationOwnershipTypeId) {
              let currentType = this.companyAffiliateTypes.find(
                (affiliateType) =>
                  affiliateType.ownershipTypeId ==
                  this.existingPersonnel.organizationOwnershipTypeId
              );
              if (currentType) {
                this.selectedAffiliateTypes.push({
                  ownershipTypeName: currentType.ownershipType,
                  organizationOwnershipTypeId: currentType.ownershipTypeId,
                });
              }
            }
            this.pending = false;
            clearInterval(t);
          }
        }, 200);
        console.log(this.existingPersonnel, 'existingPersonnel');
      },
      (error) => {
        this.pending = false;
        console.log(error);
      }
    );
  }

  checkShareholderTypeSelected() {
    return (
      this.selectedAffiliateTypes.findIndex(
        (affiliateType) =>
          affiliateType.organizationOwnershipTypeId == 'shareholder_type'
      ) != -1
    );
  }

  ngOnInit() {
    // this.document.body.classList.remove('panel');
    this.pending = true;
    this.getAffiliateTypes(this.modal.context.data.companyTypeId);
    this.getAllAfiliateTypes();
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }
}

export class NewPersonnelModal extends ComponentModalConfig<
  INewDirectorModalContext,
  void,
  void
> {
  constructor(
    title: string,
    data: any,
    isEdit: boolean,
    size: ModalSize = ModalSize.Tiny
  ) {
    super(NewPersonnelModalComponent, { title, data, isEdit });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
